/**
 * ManagePromptsModal - View and delete custom refinement prompts
 */

import { useStyleStore } from '../store/useStyleStore';
import './ManagePromptsModal.css';

interface ManagePromptsModalProps {
  onClose: () => void;
}

export function ManagePromptsModal({ onClose }: ManagePromptsModalProps) {
  const { customStyles, deleteCustomStyle } = useStyleStore();

  const handleDelete = (id: string, name: string) => {
    if (window.confirm(`Delete "${name}" style?\n\nThis cannot be undone.`)) {
      deleteCustomStyle(id);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      onKeyDown={handleKeyDown}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
        role="document"
      >
        <div className="modal-header">
          <h2 className="modal-title">Manage Refinement Prompts</h2>
          <button type="button" onClick={onClose} className="modal-close" aria-label="Close dialog">
            ✕
          </button>
        </div>

        <div className="modal-body">
          {customStyles.length === 0 ? (
            <div className="empty-state">
              <p>No custom prompts yet.</p>
              <p className="empty-hint">
                Record a refinement prompt and click "💾 Save as Prompt" to create one.
              </p>
            </div>
          ) : (
            <div className="prompts-list">
              {customStyles.map((style) => (
                <div key={style.id} className="prompt-card">
                  <div className="prompt-header">
                    <h3 className="prompt-name">✨ {style.name}</h3>
                    <button
                      type="button"
                      onClick={() => handleDelete(style.id, style.name)}
                      className="btn-delete"
                      aria-label={`Delete ${style.name}`}
                      title="Delete this prompt"
                    >
                      🗑️
                    </button>
                  </div>
                  <div className="prompt-text">{style.prompt}</div>
                  <div className="prompt-meta">
                    Created: {new Date(style.createdAt).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" onClick={onClose} className="btn-close-modal">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
